import { Building2 } from "lucide-react"
import { useNavigate } from "react-router"
import { useTranslation } from "react-i18next"

import { Card, CardContent } from "@f2e/ui/components/base"

import { useSysConfig } from "@/hooks"
import { Brand } from "@/types"
import { getResourceUrl } from "@/lib/utils"

export interface BrandCardProps {
  brand: Brand
  workspaceCount?: number
}

const BrandCard: React.FC<BrandCardProps> = ({ brand, workspaceCount = 0 }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const config = useSysConfig()

  const logoUrl = getResourceUrl(brand.logo || "", config.serverRoot)

  const handleClick = () => {
    navigate(`/brands/${brand.id}`)
  }

  return (
    <Card
      className="cursor-pointer transition-all md:hover:scale-105 hover:bg-slate-50 dark:hover:bg-slate-900"
      onClick={handleClick}
    >
      <CardContent className="p-6">
        <div className="flex items-start gap-4">
          {/* Logo */}
          <div className="shrink-0">
            {brand.logo ? (
              <img
                src={logoUrl}
                alt={brand.name}
                className="h-16 w-16 rounded-lg object-cover"
              />
            ) : (
              <div className="flex h-16 w-16 items-center justify-center rounded-lg bg-muted">
                <Building2 className="h-8 w-8 text-muted-foreground" />
              </div>
            )}
          </div>

          {/* Content */}
          <div className="flex-1 min-w-0">
            <h3 className="text-lg font-semibold truncate mb-1">
              {brand.name}
            </h3>
            <p className="h-16 text-sm text-muted-foreground line-clamp-3 mb-2">
              {brand.description}
            </p>

            {/* Metadata */}
            <div className="flex flex-wrap gap-2 text-xs text-muted-foreground">
              <div>
                {t("brands.list.workspaceCount", { count: workspaceCount })}
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}

export default BrandCard
